export default __webpack_public_path__ + "static/media/energy.f377019d.png";